export default __webpack_public_path__ + "static/media/IMG_20210329_173106~2 - 198_SAATWIK.450f7039.jpg";